import React, { useEffect, useState } from "react";
import styled from "styled-components";
import useDropdown from "../../hooks/useDropdown";

// const color = "#91ecf2";

const StyledDivBox = styled.div`
  cursor: pointer;
`;

const StyledDivMain = styled.div`
  display: flex;
  align-items: center;
`;

const StyledDivSelectedItem = styled.div`
  padding: 0.25rem;
`;

const StyledDivItems = styled.div`
  position: absolute;
  background-color: white;
  color: black;
  z-index: 100;
  box-shadow: 0.25rem 0.25rem 0.5rem #00000099;

  & > div {
    padding: 0.25rem 0.5rem;
  }

  & > div.selected {
    background-color: #e6f2ff;
  }

  & > div:not(.selected):hover {
    background-color: #b3d9ff;
  }
`;

export default function Dropdown({
  items,
  selectedId,
  handleSelectItem,
  arrowColor,
}) {
  const [dropdownRef, isOpen, setIsOpen] = useDropdown();
  const [selectedItem, setSelectedItem] = useState(items[0]);

  useEffect(() => {
    if (selectedId) {
      const selectedItems = items.filter((item) => item.id === selectedId);
      if (selectedItems.length === 1) setSelectedItem(selectedItems[0]);
    }

    return () => {
      setSelectedItem({ id: 0, value: null });
    };
  }, [items, selectedId, setSelectedItem]);

  const toggleShowItems = () => {
    setIsOpen(!isOpen);
  };

  const selectItem = (item) => {
    setSelectedItem(item);
    setIsOpen(false);
    handleSelectItem(item);
  };

  const arrowDir = isOpen ? "left" : "down";
  if (!arrowColor) arrowColor = "white";

  return items.length === 0 ? null : (
    <StyledDivBox ref={dropdownRef}>
      <div>
        {items.length === 1 ? (
          items[0].value
        ) : (
          <>
            <StyledDivMain onClick={toggleShowItems}>
              <StyledDivSelectedItem>
                {selectedItem.value}
              </StyledDivSelectedItem>
              <img
                src={`/img/icons/arrow-${arrowDir}-${arrowColor}.gif`}
                alt={`${arrowColor} ${arrowDir} arrow`}
                height={9}
                width={9}
              />
            </StyledDivMain>

            <StyledDivItems
              style={{ display: isOpen ? "block" : "none" }}
              className={"dropdown--items"}
            >
              {items.map((item) => (
                <div
                  key={item.id}
                  onClick={() => selectItem(item)}
                  className={selectedItem === item ? "selected" : ""}
                >
                  {item.value}
                </div>
              ))}
            </StyledDivItems>
          </>
        )}
      </div>
    </StyledDivBox>
  );
}
